<template>
  <div class="contents">
    <div class="opt">
      <!-- <div class="tab">
        <span
          v-permissson="'DQR'"
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="changeType(0, 'DQR')"
        >待确认({{ tabNumer.find(a => a.type === 0)?.qty || 0 }})</span
        >
        <span
          v-permissson="'YQR'"
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="changeType(1, 'YQR')"
        >已确认({{ tabNumer.find(a => a.type === 1)?.qty || 0 }})</span
        >
      </div> -->
      <div style="display: flex">
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="searchVal"
            placeholder="请输入中英文品名搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div
          v-show="computedPermissions('新增')"
          :v-permissson="computedPermissions('新增')"
          class="add flex_c_c"
          @click="add"
        >
          <svg-icon v-permissson="'add'" className="icon" iconClass="add" />
          新增
        </div>
        <div
          v-show="computedPermissions('导出')"
          :v-permissson="computedPermissions('导出')"
          class="add flex_c_c"
          @click="downloadFile"
        >
          <svg-icon className="icon" iconClass="download" /> 导出
        </div>
        <el-upload
          v-show="computedPermissions('导入')"
          :v-permissson="computedPermissions('导入')"
          action="/api/basic/tax/importProductInfo"
          :headers="headers"
          :file-list="fileList"
          :show-file-list="false"
          :limit="1"
          :on-success="handleSuccess"
          :on-error="handleError"
        >
          <div class="add flex_c_c">
            <svg-icon className="icon" iconClass="upload" /> 导入
          </div>
        </el-upload>
        <div
          v-show="computedPermissions('下载模板')"
          :v-permissson="computedPermissions('下载模板')"
          class="add flex_c_c"
          @click="download"
        >
          <svg-icon className="icon" iconClass="download" /> 下载模板
        </div>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isPager="true"
        :isEmptyBorder="true"
        @sortChange="sortChange"
        @handlePageChange="handlePageChange"
      >
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-show="computedPermissions('修改')"
                  :v-permissson="computedPermissions('修改')"
                  class="opt-item"
                  @click="handleEdit(row.scope)"
                >修改</el-button
                >
                <el-button
                  v-show="computedPermissions('删除')"
                  :v-permissson="computedPermissions('删除')"
                  class="opt-item"
                  @click="handleDelete(row.scope)"
                >删除</el-button
                >
              </div>
            </div>
            <img slot="reference" src="@/assets/images/table/opt.png" />
          </el-popover>
        </template>
        <!-- <template slot="tips" slot-scope="row">
          <p>
            <el-tag v-if="row.scope.isHold" color="#D4DDF7">查验品名</el-tag>
          </p>
          <p>
            <el-tag v-if="row.scope.isBlacklist" type="danger">黑名单</el-tag>
          </p>
          <p><el-tag @click="updateTag(row.scope)">标记 <i class="el-icon-edit" /></el-tag></p>
        </template>
        <template slot="rate" slot-scope="row">
          <p style="text-align: left;">
            <span class="label">基础税率</span>
            <span class="value">{{ row.scope.baseRate }}%</span>
          </p>
          <p style="text-align: left;">
            <span class="label">加征税率</span>
            <span class="value">{{ row.scope.addRate }}%</span>
          </p>
          <p style="text-align: left;">
            <span class="label" style="background: #AA9A50;">钢铁铝加征税率</span>
            <span class="value">{{ row.scope.addRate3 }}%</span>
          </p>
          <p style="text-align: left;">
            <span class="label">芬太尼税率</span>
            <span class="value">{{ row.scope.addRate1 }}%</span>
          </p>
          <p style="text-align: left;">
            <span class="label">对等关税税率</span>
            <span class="value">{{ row.scope.addRate2 }}%</span>
          </p>
        </template> -->
      </BaseTable>
    </div>
    <ProductAddDialog
      :dialogVisible="dialogVisible"
      :editData="editData"
      @cancel="cancel"
      @ok="ok"
    >
    </ProductAddDialog>
    <UpdateProductTagDialog
      :dialogVisible="dialogVisible1"
      :editData="editData"
      @cancel="cancel"
      @ok="ok"
    >
    </UpdateProductTagDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
import {
  getTaxProductPage,
  deleteTaxProduct,
  copyPrivateProductToPublic
} from '@/api/basic'
const ProductAddDialog = () => import('@/components/dialog/ProductAddDialog')
import UpdateProductTagDialog from './components/UpdateProductTagDialog'
import { derive, permissions } from '@/utils/common'
import { myMixins } from '@/mixins'
export default {
  name: 'Product',
  components: {
    BaseTable,
    BaseMutiInput,
    ProductAddDialog,
    UpdateProductTagDialog
  },
  mixins: [myMixins],
  data() {
    return {
      tableData: { fileds: [
          { filed: 'companyName', label: '公司名称', width: '120' },
          { filed: 'nameCH', label: '中文品名', width: '120' },
          { filed: 'nameEN', label: '英文品名', width: '120' },
          { filed: 'hsCode', label: '美国税号', width: '100' },
          { filed: 'originCountry', label: '原产国', width: '65' },
          {
            filed: 'flag',
            label: '类型',
            width: '50',
            formatter: row => (row.flag === 0 ? '普通' : row.flag === 1 ? '精选' : '无')
          },
          { filed: 'material', label: '材质', width: '100' },
          { filed: 'used', label: '用途', width: '100' },
          { filed: 'mblNo', label: '提单号', width: '180' },
          { filed: 'unitPrice', label: '单价', width: '60' },
          {
            filed: 'baseRate',
            label: '货值税率',
            width: '80',
            formatter: row => (row.baseRate > 0 ? `${row.baseRate}%` : '0')
          },
          { filed: 'baseRateWeight', label: '净重税率', width: '80' },
          { filed: 'baseRateQuantity', label: '数量税率', width: '80' },
          { filed: 'baseRateOther', label: '其他税率', width: '80' },
          {
            filed: 'addRate',
            label: '301加征',
            width: '80',
            formatter: row => (row.addRate > 0 ? `${row.addRate}%` : '0')
          },
          { filed: 'batchNo', label: '批次号1', width: '85' },
          { filed: 'batchNoExempt', label: '豁免P1', width: '70' },
          {
            filed: 'addRateTwo',
            label: '122加征',
            width: '80',
            formatter: row => (row.addRateTwo > 0 ? `${row.addRateTwo}%` : '0')
          },
          { filed: 'batchNoTwo', label: '批次号2', width: '85' },
          { filed: 'batchNoTwoExempt', label: '豁免P2', width: '70' },
          {
            filed: 'addRateThree',
            label: '钢铝加征',
            width: '80',
            formatter: row => (row.addRateThree > 0 ? `${row.addRateThree}%` : '0')
          },
          { filed: 'batchNoThree', label: '批次号3', width: '85' },
          { filed: 'batchNoThreeExempt', label: '豁免P3', width: '70' },
          {
            filed: 'addRateFour',
            label: '半导体税',
            width: '80',
            formatter: row => (row.addRateFour > 0 ? `${row.addRateFour}%` : '0')
          },
          { filed: 'batchNoFour', label: '批次号4', width: '85' },
          { filed: 'batchNoFourExempt', label: '豁免P4', width: '70' },
          {
            filed: 'addRateFive',
            label: '轻型汽配',
            formatter: row => (row.addRateFive > 0 ? `${row.addRateFive}%` : '0')
          },
          { filed: 'batchNoFive', label: '批次号5', width: '85' },
          { filed: 'batchNoFiveExempt', label: '豁免P5', width: '70' },
          {
            filed: 'addRateSix',
            label: '铜加征',
            width: '80',
            formatter: row => (row.addRateSix > 0 ? `${row.addRateSix}%` : '0')
          },
          { filed: 'batchNoSix', label: '批次号6', width: '85' },
          { filed: 'batchNoSixExempt', label: '豁免P6', width: '70' },
          {
            filed: 'addRateSeven',
            label: '木制加征',
            width: '80',
            formatter: row => (row.addRateSeven > 0 ? `${row.addRateSeven}%` : '0')
          },
          { filed: 'batchNoSeven', label: '批次号7', width: '85' },
          { filed: 'batchNoSevenExempt', label: '豁免P7', width: '70' },
          {
            filed: 'addRateEight',
            label: '中&重型卡配',
            formatter: row => (row.addRateEight > 0 ? `${row.addRateEight}%` : '0')
          },
          { filed: 'batchNoEight', label: '批次号8', width: '85' },
          { filed: 'batchNoEightExempt', label: '豁免P8', width: '70' },
          {
            filed: 'createdOn',
            label: '创建日期',
            width: '100'
          },
          {
            filed: 'isPrivate',
            label: '状态',
            width: '60',
            formatter: row => row.isPrivate ? '私有' : '公有'
          },
          { filed: 'remark', label: '备注', width: '150' },
          { filed: 'opt', label: '操作', width: '245' } // 操作列
        ],
        columns: [],
        total: 0,
        showIndex: true
      },
      loading: false,
      filterList: {},
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      sortable: {
        sortField: undefined,
        sortBy: undefined
      },
      referenceNumber: '',
      searchVal: '',
      dialogVisible: false,
      dialogVisible1: false,
      height: 0,
      editData: {},
      fileList: [],
      tabNumer: [],
      active: 0,
      activeCode: '',
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
    }
  },
  computed: {
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    }
  },
  created() {
    const menuList = this.$store.getters.initRouter
    const menu = permissions(this.$route.meta.code, menuList)
    const codeList = ['DQR', 'YQR']
    const childrenCode = menu.children.map((a) => a.code)
    this.active = codeList.findIndex((a) => childrenCode.includes(a))
    this.activeCode = menu.children[0].code
    this.getList(this.pager)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    changeType(type, code) {
      this.active = type
      this.activeCode = code
      this.pager = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.getList(this.pager)
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            hsCode: this.searchVal ? this.searchVal.split(';') : undefined
            // status: this.active
          }
        }
        const res = await getTaxProductPage(params)
        if (res.success) {
          this.loading = false
          this.tableData.columns = res.data.list.map((item) => {
            return {
              ...item,
              visible: false
            }
          })
          this.tabNumer = res.data.tabNumer
          this.tableData.total = res.data.total
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      }).then(() => {
        deleteTaxProduct({
          id: row.id
        }).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.initList()
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      })
    },
    sortChange(params) {
      console.log('params', params)
      this.sortable.sortField = params.prop || undefined
      this.sortable.sortBy =
        params.order === undefined ? undefined : params.order
      this.getList()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.searchVal = this.referenceNumber.join(';')
        }
        this.$refs.popover.doClose()
        this.initList()
      }, 0)
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    add() {
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.editData = row
      this.dialogVisible = true
    },
    async copy(row) {
      if (row.type === '公有') {
        return
      }
      try {
        const res = await copyPrivateProductToPublic({ id: row.id })
        if (res.success) {
          this.$message.success('操作成功')
          this.getList(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    ok() {
      this.cancel()
      this.initList()
    },
    initList() {
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    cancel() {
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.editData = {}
    },
    handlePageChange(pager) {
      this.pager = {
        ...pager
      }
      this.getList(pager)
    },
    download() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = `/api/SystemFile/downLoadTemplate?guid=e3udb2cx7afe41ec97v21d37xfb2o73a`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    handleSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.initList()
      } else {
        this.$message.error(res.errorMessage)
      }
      this.fileList = []
    },
    handleError(error) {
      this.$message.error(error)
      this.fileList = []
    },
    async downloadFile() {
      this.loading = true
      await derive('TaxProduct/exportTaxProduct', 'post', {
        hsCode: this.searchVal ? this.searchVal.split(';') : undefined
      })
      this.loading = false
    },
    updateTag(row) {
      this.editData = row
      this.dialogVisible1 = true
    }
  }
}
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
}
.opt {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
  .tabItem {
    padding: 20px;
    width: 42px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    cursor: pointer;
  }
  .active {
    color: rgb(18, 88, 188);
  }
  .search {
    position: relative;
    display: flex;
    width: 200px;
    margin-right: 8px;
    .searchPop {
      /deep/ .el-popover {
        z-index: 9999;
        right: 0;
      }
      .close {
        position: absolute;
        top: 6px;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    .input-search {
      width: 166px;
      height: 30px !important;
      /deep/ .el-input__inner {
        height: 30px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-search {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border: 1px solid #dbe4f2;
      border-left: 0;
      border-radius: 0 4px 4px 0;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.add {
  width: 84px;
  height: 30px;
  background: rgb(18, 88, 188);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  svg {
    font-size: 20px;
  }
}
.data {
  width: 100%;
  height: calc(100% - 54px);
  z-index: 1;
  & .fTable {
    border-top: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  &:deep(.el-button) + .el-button {
    margin-left: 20px;
  }
  &:deep(.el-button--text) {
    padding: 0;
  }
  p + p {
    margin-top: 2px;
  }
  .label {
    width: 96px;
    height: 18px;
    display: inline-block;
    line-height: 18px;
    text-align: center;
    background: #768292;
    border-radius: 4px 4px 4px 4px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
  }
  .value {
    margin-left: 8px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: bold;
    font-size: 14px;
    color: #666666;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
